import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CustomerAutoComplete from '../common/customerautocomplete';
import ConfirmationDialog from '../common/confirmationdialog';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';

const styles = {
    removeRep: { color: 'red' },
};

export default function RepresentationsList(props) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const customers = useSelector((state) => state.customerdata.allCustomers);
    const [showAddNewRep, setShowAddNewRep] = useState(false);
    const [toRemoveRep, setToRemoveRep] = useState({});
    const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);
    const representations = props.representations;
    const allowEdit = props.allowEdit;
    const { t } = useTranslation();

    useEffect(() => {});

    const removeRep = (rep) => {
        setToRemoveRep(rep);
        setShowRemoveConfirm(true);
    };

    const customerSelected = (_id, customer) => {
        setShowAddNewRep(false);
        const newReps = cloneDeep(representations);
        newReps.push({ customerId: customer.id, customerName: customer.name });
        props.representationsChanged(newReps);
    };

    const confirmRemoveRep = (rep) => {
        setShowRemoveConfirm(false);
        const newReps = cloneDeep(representations);
        newReps.splice(
            newReps.findIndex((elem) => elem.customerId === rep.customerId),
            1
        );
        props.representationsChanged(newReps);
        setToRemoveRep({});
    };

    const cancelRemoveRep = () => {
        setToRemoveRep({});
        setShowRemoveConfirm(false);
    };

    return (
        <Grid container>
            {!!representations && representations.length > 0 && (
                <Grid container item>
                    <Grid item>
                        {representations.map((rep) => (
                            <Grid item key={rep.customerId}>
                                <em>{rep.customerName}</em>
                                &nbsp;
                                {allowEdit && (
                                    <Button
                                        size="small"
                                        name="remove-representation"
                                        sx={styles.removeRep}
                                        onClick={() => removeRep(rep)}
                                        title={t('buttons.remove')}>
                                        <DeleteIcon />
                                    </Button>
                                )}
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            )}
            {allowEdit && (
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setShowAddNewRep(true)}
                        name="add-representation">
                        <AddIcon />
                    </Button>
                </Grid>
            )}

            {allowEdit && (
                <Dialog open={showAddNewRep} fullWidth={true} maxWidth={'md'} fullScreen={fullScreen}>
                    <DialogContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <CustomerAutoComplete
                                    customers={customers ? customers : []}
                                    selected={customerSelected}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            color="inherit"
                            name="add-rep-cancel"
                            onClick={() => setShowAddNewRep(false)}>
                            {t('buttons.cancel')}
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
            {allowEdit && (
                <ConfirmationDialog
                    open={showRemoveConfirm}
                    cancel={cancelRemoveRep}
                    confirm={() => confirmRemoveRep(toRemoveRep)}>
                    {t('admin.confirmRemoveRep')} <strong>{toRemoveRep.customerName}</strong>{' '}
                </ConfirmationDialog>
            )}
        </Grid>
    );
}

RepresentationsList.propTypes = {
    representations: PropTypes.array.isRequired,
    allowEdit: PropTypes.bool.isRequired,
    representationsChanged: PropTypes.func,
};
